module.exports = __webpack_public_path__ + "static/media/letter-spacing-white.fefa81c5.svg";